module.exports = __webpack_public_path__ + "static/media/ic_participants_stop.009be95e.svg";